
import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";

interface EmptyTableMessageProps {
  colSpan: number;
  message: string;
}

export function EmptyTableMessage({ colSpan, message }: EmptyTableMessageProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="text-center py-4 text-muted-foreground">
        {message}
      </TableCell>
    </TableRow>
  );
}
